import React, { Component } from 'react';
import { connect } from 'react-redux';
import Waypoint from 'react-waypoint';

import getVisibleQualities from 'selectors/possessions/getVisibleQualities';
import InventoryGroupComponent from './InventoryGroupComponent';
import { IAppState } from 'types/app';

export class InventoryGroupContainer extends Component<OwnProps & StateProps> {
  static displayName = 'InventoryGroupContainer';

  handleEnter = () => {
    const { id, onEnter } = this.props;
    onEnter(id);
  };

  render = () => {
    const { name, qualities } = this.props;
    if (!qualities.length) {
      return null;
    }
    return (
      <Waypoint
        bottomOffset="70%"
        onEnter={this.handleEnter}
      >
        <div>
          <InventoryGroupComponent
            name={name}
            qualities={qualities}
          />
        </div>
      </Waypoint>
    );
  }
}

interface OwnProps {
  filterString: string,
  onEnter: Function,
  id: number,
  name: string,
  qualities: number[],
}

interface StateProps {
  qualities: any[],
}

const mapStateToProps = (state: IAppState, props: OwnProps) => ({
  qualities: getVisibleQualities(state, props),
});

export default connect(mapStateToProps)(InventoryGroupContainer);